export const useCustomLink = function () {
  const runtimeConfig = useRuntimeConfig()
  const BASE_URL = runtimeConfig.app.baseURL
  const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()

  function getNuxtLink(URI) {
    if (isWebViewFlag) {
      return URI
    } else {
      const NEW_URI = URI.replace(BASE_URL, '/')
      return NEW_URI
    }
  }

  function isExternal() {
    return !!isWebViewFlag
  }

  return {
    getNuxtLink,
    isExternal
  }
}
